import axios from 'axios'
import { expireSession } from '@/services/session'

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

axiosInstance.interceptors.request.use((config) => {
    if(!config.url.includes('/auth')) {
        const bearer = `Bearer ${window.localStorage.getItem('access_token')}`
        // merge (don't replace) so per-request headers like multipart
        // Content-Type survive alongside the auth token. Since axios 1.x
        // config.headers is an AxiosHeaders instance, not a plain object.
        if (config.headers && typeof config.headers.set === 'function') {
            config.headers.set('Authorization', bearer)
        } else {
            config.headers = {
                ...(config.headers || {}),
                'Authorization': bearer
            }
        }
    }

    return config
})

axiosInstance.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
}, function (error) {
  // Session expired / unauthorised: tell the backend, then hand off to the
  // session detector which clears storage, shows a toast and redirects.
    if (error.response && (error.response.status == 401 || error.response.status == 403)) {
        // send the token so the backend audits who logged out. If the token is
        // expired, the backend falls back to the email in `user` localStorage.
        const t = window.localStorage.getItem('access_token') || ''
        let email = ''
        try { email = (JSON.parse(window.localStorage.getItem('user') || '{}').email) || '' } catch (e) { email = '' }
        axios.get(`${process.env.VUE_APP_API_URL}/auth/logkeluar?token=${t}&email=${encodeURIComponent(email)}`).catch(() => {})
        expireSession();
    }
  return Promise.reject(error);
});

export default axiosInstance